// src/components/EmailScreen.js
import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { FormContext } from "../context/FormContext";
import Header from "./Header";

const EmailScreen = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const { updateFormData } = useContext(FormContext);

  const handleNext = () => {
    if (email.trim()) {
      updateFormData({ email });
      navigate("/topic", { state: { email } });
    }
  };

  return (
    <div>
      <Header />
      <div className="center flex flex-col items-center h-screen">
        <div className="flex flex-col items-start justify-center w-full h-screen gap-6 max-w-sm md:max-w-md">
          <p className="text-[#0D3C26] text-xl">
            Hey there, great to meet you!I'm Brew, your personal AI learning
            assistant
          </p>
          <p className="text-[#0D3C26] text-xl">
            My goal is to make learning as effortless as possible and help you
            include it in your daily routine. I am going to send you bit sized
            tutorials to your mailbox everyday and track it for you.
          </p>
          <p className="text-[#0D3C26] text-xl">To continue and receieve your personalized daily tutorials,</p>
          <div className="w-full rounded-full flex bg-white px-4 justify-between items-center h-14">
          <input
            type="email"
            value={email}
            className="placeholder:text-[#0d3c26b2] w-full  focus:outline-none outline-none text-[#0D3C26] text-base md:text-xl "
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
          />
          <button  className={`text-[#0D3C26] disabled:text-[#7b7b77] bg-[#FAF3EA] rounded-full px-3 py-1.5  font-semibold  text-center flex justify-center items-center ${!/\S+@\S+\.\S+/.test(email) ? 'disabled:cursor-not-allowed' : ''}`} disabled={!/\S+@\S+\.\S+/.test(email)} onClick={handleNext}>Continue</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailScreen;
